import { NavLink, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  ArrowRight,
  Home,
  Info,
  CheckCircle2,
  BookOpen,
  Briefcase,
  PhoneCall,
  Handshake,
} from "lucide-react";
import { Button } from "../ui/button";
import { NAV_LINKS } from "../../constants";

const NAV_ICONS = {
  "/": Home,
  "/about": Info,
  "/why-choose-us": CheckCircle2,
  "/blog": BookOpen,
  "/careers": Briefcase,
  "/contact": PhoneCall,
};

export default function MobileNav({ open, onClose, onPartnerClick }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.98 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="mt-2 overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-2xl shadow-slate-900/10 lg:hidden"
        >
          <div className="flex flex-col gap-1.5 text-sm font-medium text-gray-700">
            {NAV_LINKS.map((l) => {
              const IconComponent = NAV_ICONS[l.to];
              return (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-xl px-4 py-2.5 transition-all duration-200 hover:bg-[#0B5D4B]/5 hover:text-[#0B5D4B] ${
                      isActive ? "bg-[#0B5D4B]/10 font-semibold text-[#0B5D4B]" : ""
                    }`
                  }
                >
                  <div className="flex items-center gap-3">
                    {IconComponent && (
                      <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#0B5D4B]/10 text-[#0B5D4B]">
                        <IconComponent size={14} />
                      </div>
                    )}
                    <span>{l.label}</span>
                  </div>
                  <ArrowRight size={14} className="opacity-40" />
                </NavLink>
              );
            })}
            <div className="mt-3 flex flex-col gap-2.5 border-t border-black/5 pt-3">
              <Button
                asChild
                className="w-full rounded-full bg-[#0B5D4B] py-5 text-sm font-semibold text-white shadow-md shadow-[#0B5D4B]/25 hover:bg-[#063B30] active:scale-95 cursor-pointer"
                data-testid="mobile-partner-btn"
              >
                <Link to="/contact" onClick={onClose} className="inline-flex items-center justify-center gap-2">
                  <Handshake size={18} />
                  <span>Partner With Us</span>
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
